export default __webpack_public_path__ + "img/main.connect-calendar@3x.e603e0d5.png";